var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
import { nanoid } from 'nanoid';
import { ModelStream } from './ModelStream';
import { memoize } from '../../utils/mobx/decorators/memoize';
import { ModelAvailable } from './ModelAvailable';
export class Model {
    get id() {
        return nanoid(6);
    }
    owner;
    constructor(owner) {
        this.owner = owner;
    }
    get stream() {
        return new ModelStream(this);
    }
    get available() {
        return new ModelAvailable(this);
    }
    getNewModel(owner) {
        return new Model(owner);
    } // circular reference reasons for this
}
__decorate([
    memoize
], Model.prototype, "id", null);
__decorate([
    memoize
], Model.prototype, "stream", null);
__decorate([
    memoize
], Model.prototype, "available", null);
